// Единая иконочная система: line-иконки 24×24, stroke 1.5, currentColor.
// Заменяет эмодзи по всему приложению. Размер задаётся пропом size (по умолчанию 20).

import type { ReactNode, SVGProps } from 'react';

export type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Base({ size = 20, children, ...rest }: IconProps & { children: ReactNode }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  );
}

/* ── Таббар и меню разделов ── */

export function HomeIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M3.5 10.5 12 3.5l8.5 7" />
      <path d="M5.5 9.5V20h13V9.5" />
      <path d="M10 20v-5.5h4V20" />
    </Base>
  );
}

export function ListIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M4 6h2.5M10 6h10M4 12h2.5M10 12h10M4 18h2.5M10 18h10" />
    </Base>
  );
}

export function BankIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M3.5 9 12 4l8.5 5" />
      <path d="M5.5 9.5V17M10 9.5V17M14 9.5V17M18.5 9.5V17" />
      <path d="M3.5 20h17" />
    </Base>
  );
}

export function TagIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M3.5 10V4.5a1 1 0 0 1 1-1H10l10 10a1.4 1.4 0 0 1 0 2l-4.5 4.5a1.4 1.4 0 0 1-2 0l-10-10Z" />
      <path d="M7.7 7.7h.01" />
    </Base>
  );
}

export function TargetIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="12" cy="12" r="0.8" fill="currentColor" stroke="none" />
    </Base>
  );
}

export function BarsIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M5.5 19.5v-6M12 19.5v-13M18.5 19.5v-9" />
      <path d="M3.5 19.5h17" />
    </Base>
  );
}

export function PulseIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M3 12.5h3.5L9 6.5l4.5 11 2-5h5.5" />
    </Base>
  );
}

/* ── Действия ── */

export function PencilIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="m4.5 19.5 1-3.6L16.4 5a1.8 1.8 0 0 1 2.6 2.6L8.1 18.5l-3.6 1Z" />
      <path d="m14.6 6.8 2.6 2.6" />
    </Base>
  );
}

export function TrashIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M4.5 6.5h15" />
      <path d="M9.5 6.5V4.5h5v2" />
      <path d="M6.5 6.5 7.3 20h9.4l.8-13.5" />
      <path d="M10 10.5v6M14 10.5v6" />
    </Base>
  );
}

export function EyeIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="2.7" />
    </Base>
  );
}

export function EyeOffIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M4 4.5 20 20" />
      <path d="M10.3 6a10 10 0 0 1 1.7-.5c6-1 9.5 6.5 9.5 6.5a17.4 17.4 0 0 1-2.6 3.2M6.4 6.9A16.8 16.8 0 0 0 2.5 12S6 18.5 12 18.5a9.6 9.6 0 0 0 4.2-1" />
      <path d="M10 10.1a2.7 2.7 0 0 0 3.8 3.8" />
    </Base>
  );
}

export function FilterIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M4 5h16l-6 7.2v5.3L10 19v-6.8L4 5Z" />
    </Base>
  );
}

export function RefreshIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M21 12a9 9 0 1 1-2.6-6.4L21 8" />
      <path d="M21 3.5V8h-4.5" />
    </Base>
  );
}

export function ChevronLeftIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="m14.5 5.5-6.5 6.5 6.5 6.5" />
    </Base>
  );
}

export function ChevronRightIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="m9.5 5.5 6.5 6.5-6.5 6.5" />
    </Base>
  );
}

export function ChevronDownIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="m5.5 9.5 6.5 6.5 6.5-6.5" />
    </Base>
  );
}

export function CloseIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M5.5 5.5l13 13M18.5 5.5l-13 13" />
    </Base>
  );
}

export function PlusIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M12 5v14M5 12h14" />
    </Base>
  );
}

export function CheckIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="m4.5 12.5 5 5L19.5 7" />
    </Base>
  );
}

export function ArrowUpRightIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M6.5 17.5 17.5 6.5" />
      <path d="M8.5 6.5h9v9" />
    </Base>
  );
}

export function ArrowDownLeftIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M17.5 6.5 6.5 17.5" />
      <path d="M15.5 17.5h-9v-9" />
    </Base>
  );
}

export function SearchIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4.5 4.5" />
    </Base>
  );
}

/* ── Метрики и статусы ── */

export function WalletIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <rect x="3" y="6" width="18" height="13.5" rx="2" />
      <path d="M3 9.5h18" />
      <path d="M15.5 14.5h2.5" />
    </Base>
  );
}

export function ShieldIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M12 3.5 19 6v6c0 4.5-3 7.5-7 8.5-4-1-7-4-7-8.5V6Z" />
    </Base>
  );
}

export function DropletIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M12 3.5S6 10 6 14a6 6 0 0 0 12 0c0-4-6-10.5-6-10.5Z" />
    </Base>
  );
}

export function CalendarIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    </Base>
  );
}

export function FlameIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M12 3.5c.6 3.4-4.5 5.4-4.5 10a4.5 4.5 0 0 0 9 0c0-2.4-1.3-3.9-2.4-5-.2 1.4-.9 2.2-1.9 2.5.5-2.3.3-5-0.2-7.5Z" />
    </Base>
  );
}

export function RepeatIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M17 2.5 20.5 6 17 9.5" />
      <path d="M3.5 11V9a3 3 0 0 1 3-3h14" />
      <path d="M7 21.5 3.5 18 7 14.5" />
      <path d="M20.5 13v2a3 3 0 0 1-3 3h-14" />
    </Base>
  );
}

export function StoreIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M4.5 9.5V20h15V9.5" />
      <path d="M3 6.5 4.5 3h15L21 6.5v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1Z" />
      <path d="M9.5 20v-5.5h5V20" />
    </Base>
  );
}

export function FlagIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M5 21V4" />
      <path d="M5 4.5c4-2 6.5 2 11 0v8c-4.5 2-7-2-11 0" />
    </Base>
  );
}

export function TimerIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="13.5" r="7" />
      <path d="M12 13.5v-4M9.5 3h5" />
    </Base>
  );
}

export function BanIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m6 6 12 12" />
    </Base>
  );
}

export function UserIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </Base>
  );
}

export function AlertTriangleIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M12 4 21.5 20h-19L12 4Z" />
      <path d="M12 10v4.5" />
      <path d="M12 17.3h.01" />
    </Base>
  );
}

export function LockIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <rect x="5" y="10.5" width="14" height="10" rx="2" />
      <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
    </Base>
  );
}

export function InfoIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11.5V16" />
      <path d="M12 8h.01" />
    </Base>
  );
}

export function CheckCircleIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.5 12.5 2.5 2.5 4.5-5.5" />
    </Base>
  );
}

/* ── Типы долгов ── */

export function PercentIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M19 5 5 19" />
      <circle cx="7" cy="7" r="2.4" />
      <circle cx="17" cy="17" r="2.4" />
    </Base>
  );
}

export function BadgePercentIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m15.3 8.7-6.6 6.6" />
      <path d="M9.3 9.3h.01M14.7 14.7h.01" />
    </Base>
  );
}

export function CartIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M3 4.5h2l2.4 11.5h10.2L20 8H6" />
      <circle cx="9" cy="19.7" r="1.1" />
      <circle cx="16.5" cy="19.7" r="1.1" />
    </Base>
  );
}

export function BriefcaseIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <rect x="3.5" y="7.5" width="17" height="12.5" rx="2" />
      <path d="M9 7.5v-2A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5v2" />
      <path d="M3.5 12.5h17" />
    </Base>
  );
}

export function UsersIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="9" cy="8.5" r="3" />
      <path d="M3.5 19.5a5.5 5.5 0 0 1 11 0" />
      <path d="M16 6.2a3 3 0 0 1 0 5.6" />
      <path d="M17.5 14.6a5.5 5.5 0 0 1 3 4.9" />
    </Base>
  );
}

// --- Тема оформления -------------------------------------------------------

export function MoonIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <path d="M20 14.2A8.2 8.2 0 0 1 9.8 4a8.5 8.5 0 1 0 10.2 10.2Z" />
    </Base>
  );
}

export function SunIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.5 1.5M17.9 17.9l1.5 1.5M2.5 12h2M19.5 12h2M4.6 19.4l1.5-1.5M17.9 6.1l1.5-1.5" />
    </Base>
  );
}

export function MonitorIcon(p: IconProps): JSX.Element {
  return (
    <Base {...p}>
      <rect x="2.75" y="4" width="18.5" height="12.5" rx="2" />
      <path d="M8.5 20.5h7M12 16.5v4" />
    </Base>
  );
}
